import { lazy } from "react";
import Loadable from "app/components/Loadable";



const FlashCards = Loadable(lazy(() => import("./FlashCards/FlashCards")));
const UserTable = Loadable(lazy(() => import("./users/User")));
const NotificationDialog=Loadable(lazy(() => import("./pushNotifications/PushNotifications")));
// 
const pagesRoutes = [
  { path: "/FlashCards/FlashCards", element: <FlashCards /> },
  { path: "/users/User", element: <UserTable /> },
  { path: "/pushNotifications/PushNotifications", element: <NotificationDialog /> }
];

export default pagesRoutes;
